import { render, staticRenderFns } from "./oneColumnCard.vue?vue&type=template&id=8883bca4&scoped=true"
import script from "./oneColumnCard.vue?vue&type=script&lang=js"
export * from "./oneColumnCard.vue?vue&type=script&lang=js"
import style0 from "./oneColumnCard.vue?vue&type=style&index=0&id=8883bca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8883bca4",
  null
  
)

export default component.exports